module.exports = __webpack_public_path__ + "img/img5-8.b65efd10.png";